window.CarMakesData = {
  data: [
    {
      id: 4146,
      original_name: 'Abarth',
      name: 'Abarth',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1,
      original_name: 'AC',
      name: 'AC',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 2,
      original_name: 'Acura',
      name: 'Acura',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000004,
      original_name: 'Aiways',
      name: 'Aiways',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000005,
      original_name: 'Aixam',
      name: 'Aixam',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 3,
      original_name: 'Alfa Romeo',
      name: 'Alfa Romeo',
      is_popular: 0,
      car_category_key: 'standard',
      car_category_name: 'Standard',
    },
    {
      id: 4,
      original_name: 'Alpine',
      name: 'Alpine',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 9,
      original_name: 'Aston Martin',
      name: 'Aston Martin',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 10,
      original_name: 'Audi',
      name: 'Audi',
      is_popular: 1,
      car_category_key: 'standard',
      car_category_name: 'Standard',
    },
    {
      id: 3749,
      original_name: 'Austin Healey',
      name: 'Austin Healey',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 14,
      original_name: 'BAIC (Beijing)',
      name: 'BAIC (Beijing)',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 3751,
      original_name: 'BAW',
      name: 'BAW',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 15,
      original_name: 'Bentley',
      name: 'Bentley',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 18,
      original_name: 'BMW',
      name: 'BMW',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 24,
      original_name: 'Bugatti',
      name: 'Bugatti',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 25,
      original_name: 'Buick',
      name: 'Buick',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 26,
      original_name: 'BYD',
      name: 'BYD',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 28,
      original_name: 'Cadillac',
      name: 'Cadillac',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 31,
      original_name: 'Caterham',
      name: 'Caterham',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 34,
      original_name: 'Chery',
      name: 'Chery',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 35,
      original_name: 'Chevrolet',
      name: 'Chevrolet',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 36,
      original_name: 'Chrysler',
      name: 'Chrysler',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 37,
      original_name: 'Citroen',
      name: 'Citroen',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4203,
      original_name: 'Cupra',
      name: 'Cupra',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000056,
      original_name: 'Custom Regular Mats',
      name: 'Custom Regular Mats',
      is_popular: 0,
      car_category_key: 'standard',
      car_category_name: 'Standard',
    },
    {
      id: 1000000055,
      original_name: 'Custom Van Mats',
      name: 'Custom Van Mats',
      is_popular: 0,
      car_category_key: 'van',
      car_category_name: 'Van',
    },
    {
      id: 40,
      original_name: 'Dacia',
      name: 'Dacia',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 42,
      original_name: 'Daewoo',
      name: 'Daewoo',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 44,
      original_name: 'Daihatsu',
      name: 'Daihatsu',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 3754,
      original_name: 'DFSK',
      name: 'DFSK',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 51,
      original_name: 'Dodge',
      name: 'Dodge',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4319,
      original_name: 'DR',
      name: 'DR',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 3589,
      original_name: 'DS (Citroen)',
      name: 'DS (Citroen)',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000016,
      original_name: 'E.GO',
      name: 'E.GO',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000037,
      original_name: 'EMC',
      name: 'EMC',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 5233,
      original_name: 'Fengon (DFSK)',
      name: 'Fengon (DFSK)',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 60,
      original_name: 'Ferrari',
      name: 'Ferrari',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 61,
      original_name: 'Fiat',
      name: 'Fiat',
      is_popular: 0,
      car_category_key: 'standard',
      car_category_name: 'Standard',
    },
    {
      id: 62,
      original_name: 'Fisker',
      name: 'Fisker',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 63,
      original_name: 'Ford',
      name: 'Ford',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4364,
      original_name: 'Forthing',
      name: 'Forthing',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 65,
      original_name: 'FSO',
      name: 'FSO',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 216,
      original_name: 'GAZ',
      name: 'GAZ',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 67,
      original_name: 'Geely',
      name: 'Geely',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 3815,
      original_name: 'Genesis',
      name: 'Genesis',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 69,
      original_name: 'GMC',
      name: 'GMC',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 71,
      original_name: 'Great Wall / Haval',
      name: 'Great Wall / Haval',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 76,
      original_name: 'Honda',
      name: 'Honda',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4213,
      original_name: 'Hongqi',
      name: 'Hongqi',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 78,
      original_name: 'Hummer',
      name: 'Hummer',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 79,
      original_name: 'Hyundai',
      name: 'Hyundai',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000006,
      original_name: 'Ineos',
      name: 'Ineos',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 80,
      original_name: 'Infiniti',
      name: 'Infiniti',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 81,
      original_name: 'Innocenti',
      name: 'Innocenti',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 85,
      original_name: 'Isuzu',
      name: 'Isuzu',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 86,
      original_name: 'IVECO',
      name: 'IVECO',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 87,
      original_name: 'JAC / Sehol',
      name: 'JAC / Sehol',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 5042,
      original_name: 'Jaecoo',
      name: 'Jaecoo',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 88,
      original_name: 'Jaguar',
      name: 'Jaguar',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 89,
      original_name: 'Jeep',
      name: 'Jeep',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 5045,
      original_name: 'KG Mobility',
      name: 'KG Mobility',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 92,
      original_name: 'Kia',
      name: 'Kia',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 215,
      original_name: 'Lada (VAZ)',
      name: 'Lada (VAZ)',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 95,
      original_name: 'Lamborghini',
      name: 'Lamborghini',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 96,
      original_name: 'Lancia',
      name: 'Lancia',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 97,
      original_name: 'Land Rover',
      name: 'Land Rover',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4310,
      original_name: 'Leapmotor',
      name: 'Leapmotor',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 99,
      original_name: 'Lexus',
      name: 'Lexus',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4170,
      original_name: 'Ligier',
      name: 'Ligier',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 102,
      original_name: 'Lincoln',
      name: 'Lincoln',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 103,
      original_name: 'Lotus',
      name: 'Lotus',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 104,
      original_name: 'LTI',
      name: 'LTI',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000000,
      original_name: 'Lynk & Co',
      name: 'Lynk & Co',
      is_popular: 0,
      car_category_key: 'electro',
      car_category_name: 'Electro',
    },
    {
      id: 111,
      original_name: 'Maserati',
      name: 'Maserati',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 3764,
      original_name: 'Maxus',
      name: 'Maxus',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 113,
      original_name: 'Mazda',
      name: 'Mazda',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 114,
      original_name: 'McLaren',
      name: 'McLaren',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 116,
      original_name: 'Mercedes-Benz',
      name: 'Mercedes-Benz',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 119,
      original_name: 'MG',
      name: 'MG',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 120,
      original_name: 'Microcar',
      name: 'Microcar',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 122,
      original_name: 'Mini',
      name: 'Mini',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 123,
      original_name: 'Mitsubishi',
      name: 'Mitsubishi',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 125,
      original_name: 'Morgan',
      name: 'Morgan',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 127,
      original_name: 'Nissan',
      name: 'Nissan',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4318,
      original_name: 'Omoda',
      name: 'Omoda',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 130,
      original_name: 'Opel',
      name: 'Opel',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4361,
      original_name: 'ORA',
      name: 'ORA',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 135,
      original_name: 'Peugeot',
      name: 'Peugeot',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4200,
      original_name: 'Polestar',
      name: 'Polestar',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 138,
      original_name: 'Pontiac',
      name: 'Pontiac',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 139,
      original_name: 'Porsche',
      name: 'Porsche',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 147,
      original_name: 'Renault',
      name: 'Renault',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 149,
      original_name: 'Rolls-Royce',
      name: 'Rolls-Royce',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 151,
      original_name: 'Rover',
      name: 'Rover',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 152,
      original_name: 'Saab',
      name: 'Saab',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 156,
      original_name: 'Scion',
      name: 'Scion',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 157,
      original_name: 'SEAT',
      name: 'SEAT',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4327,
      original_name: 'Seres',
      name: 'Seres',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 159,
      original_name: 'Skoda',
      name: 'Skoda',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4217,
      original_name: 'Skywell',
      name: 'Skywell',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 160,
      original_name: 'Smart',
      name: 'Smart',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 165,
      original_name: 'SsangYong',
      name: 'SsangYong',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 166,
      original_name: 'Subaru',
      name: 'Subaru',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 167,
      original_name: 'Suzuki',
      name: 'Suzuki',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4369,
      original_name: 'SWM',
      name: 'SWM',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 169,
      original_name: 'Tata',
      name: 'Tata',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 172,
      original_name: 'Tesla',
      name: 'Tesla',
      is_popular: 1,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 176,
      original_name: 'Toyota',
      name: 'Toyota',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 177,
      original_name: 'Trabant',
      name: 'Trabant',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000052,
      original_name: 'Trapper',
      name: 'Trapper',
      is_popular: 0,
      car_category_key: 'standard',
      car_category_name: 'Standard',
    },
    {
      id: 227,
      original_name: 'UAZ',
      name: 'UAZ',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 181,
      original_name: 'Vauxhall',
      name: 'Vauxhall',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4367,
      original_name: 'VinFast',
      name: 'VinFast',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 184,
      original_name: 'Volkswagen',
      name: 'Volkswagen',
      is_popular: 1,
      car_category_key: 'standard',
      car_category_name: 'Standard',
    },
    {
      id: 185,
      original_name: 'Volvo',
      name: 'Volvo',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4307,
      original_name: 'Voyah',
      name: 'Voyah',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4362,
      original_name: 'WEY',
      name: 'WEY',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 189,
      original_name: 'Wiesmann',
      name: 'Wiesmann',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 5241,
      original_name: 'XEV',
      name: 'XEV',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 5242,
      original_name: 'Xiaomi',
      name: 'Xiaomi',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4192,
      original_name: 'Xpeng',
      name: 'Xpeng',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 4309,
      original_name: 'Zeekr',
      name: 'Zeekr',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
    {
      id: 1000000001,
      original_name: 'Zhidou',
      name: 'Zhidou',
      is_popular: 0,
      car_category_key: null,
      car_category_name: null,
    },
  ],
  status: true,
  extra_data: [],
};
